<template>
  <div>
    <div v-for="(subabschnitt, idx2) in abschnitt.abschnitte.sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)" :key="idx2" class="ms-3">
      <div v-if="displayAbschnitt(idx2)" class="d-flex align-items-center mb-1">
        <input
          class="form-check-input"
          type="checkbox"
          :id="'subabschnitt-' + idx + '-' + idx2 + '-' + subabschnitt.id"
          v-model="subabschnitt.selected"
          @change="selectionChanged(subabschnitt.textbausteinid)"
          :disabled="
            forbiddenAbschnitte.map((item) => item.value).includes(subabschnitt.textbausteinid) ||
            requiredAbschnitte.map((item) => item.value).includes(subabschnitt.textbausteinid)
          "
        />
        <label
          class="form-check-label flex-fill ms-2 p-2 shadow-sm abschnittRow"
          :class="{ selectedAbschnitt: subabschnitt.selected }"
          :for="'subabschnitt-' + idx + '-' + idx2 + '-' + subabschnitt.id"
        >
          <SelectAbschnittRow :abschnitt="subabschnitt" />
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed } from 'vue';
  import { useStore } from '@/store';

  import { TextAbschnitt, Vertrag } from '@/models/VertragModels';
  import { Vorlage, VorlageAbschnittRegel } from '@/models/VorlageModels';
  import { KeyValuePair } from '@/models/CommonModels';

  import SelectAbschnittRow from '../SelectAbschnittRow.vue';
  //#endregion

  const { abschnitt, editVertrag, idx } = defineProps({
    abschnitt: {
      type: Object as PropType<TextAbschnitt>,
      required: true,
    },

    editVertrag: {
      type: Object as PropType<Vertrag>,
      required: true,
    },

    requiredAbschnitte: {
      type: Array as PropType<Array<KeyValuePair>>,
      required: true,
    },

    forbiddenAbschnitte: {
      type: Array as PropType<Array<KeyValuePair>>,
      required: true,
    },

    idx: {
      type: Number as PropType<number>,
      required: true,
    },
  });

  const store = useStore();

  const emit = defineEmits(['checkRegeln']);

  const vorlage = computed(() => store.getters.vorlagen.find((v: Vorlage) => v.id == editVertrag.vorlageid));

  function selectionChanged(textbausteinid: number) {
    setParentAsSelected(textbausteinid);
    emit('checkRegeln', textbausteinid, 0);
  }

  function setParentAsSelected(textbausteinid: number) {
    if (abschnitt) {
      // var subabschnitt = abschnitt.abschnitte.sort((sa, sb) => sa.position - sb.position)[subabschnittIdx];
      var subabschnitt = abschnitt.abschnitte.find((sa) => sa.textbausteinid == textbausteinid);
      if (subabschnitt && subabschnitt.selected) {
        abschnitt.selected = true;
      }
    }
  }

  function getAbschnittRegel(abschnittIdx: number): VorlageAbschnittRegel | undefined {
    const abschn = abschnitt.abschnitte.sort((a, b) => a.position - b.position)[abschnittIdx];

    if (abschn) {
      const vorlageTextbaustein = vorlage.value?.vorlageTextbausteine.find((vtb) => vtb.textbausteinid == abschnitt.textbausteinid);
      return vorlageTextbaustein?.abschnittRegeln.find((ar) => ar.textbausteinId == abschn.textbausteinid);
    }

    return undefined;
  }

  function displayAbschnitt(abschnittIdx: number): boolean {
    const regel = getAbschnittRegel(abschnittIdx);

    if (regel != undefined && regel.optional && regel.aktiv) {
      return true;
    }

    return false;
  }
</script>

<style scoped>
  .abschnittRow {
    background: white;
    cursor: pointer;
  }

  .abschnittRow:hover {
    /* background: #ffd1df;
  color: #770025; */
    background: #fff4af;
  }

  .selectedAbschnitt {
    /* background: #ffd1df;
  color: #770025; */
    background: #fff4af;
  }
</style>
